module.exports = __webpack_public_path__ + "img/special_bg.4eac0ffe.png";